var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2,
  height: 10
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1",
  d: "M.003 6V0h2v6zm0 3V7h2v2z",
  fill: "#ee6e7c"
})));
export default SvgExclamation;